module.exports = __webpack_public_path__ + "img/labmemtest_text_btn02_jp.ed88566b.png";